import React from 'react';
import { FaArrowLeft, FaExclamationTriangle, FaTools } from 'react-icons/fa';
import CareConciergeLogo from '../../assets/Care_Concierge_Logo.png';
import './maintenanceExternal.scss';

export function MaintenancePageShell({ children, staffName, centreName, onBack, action }) {
  return (
    <main className="maintenance-external">
      <header className="maintenance-external__header">
        <div className="maintenance-external__header-inner">
          {onBack && (
            <button type="button" className="maintenance-icon-button" onClick={onBack} aria-label="Back to maintenance tasks">
              <FaArrowLeft aria-hidden="true" />
            </button>
          )}
          <img src={CareConciergeLogo} alt="Care Concierge" className="maintenance-external__logo" />
          <div className="maintenance-external__identity">
            <span><FaTools aria-hidden="true" /> Maintenance</span>
            {staffName && <strong>{staffName}</strong>}
            {centreName && <small>{centreName}</small>}
          </div>
          {action && <div className="maintenance-external__header-action">{action}</div>}
        </div>
      </header>
      <div className="maintenance-external__content">{children}</div>
    </main>
  );
}

export function MaintenanceLinearLoading({ title = 'Loading maintenance tasks', detail = 'Getting the latest information...' }) {
  return (
    <section className="maintenance-linear-loading" role="status" aria-live="polite" aria-busy="true">
      <div>
        <span>Care Guardian</span>
        <strong>{title}</strong>
        <p>{detail}</p>
      </div>
    </section>
  );
}

export function MaintenanceErrorState({ title = 'Maintenance tasks could not be loaded', message, onRetry }) {
  return (
    <section className="maintenance-state-card" role="alert">
      <div className="maintenance-state-card__icon"><FaExclamationTriangle aria-hidden="true" /></div>
      <h1>{title}</h1>
      <p>{message}</p>
      {onRetry && <button type="button" className="maintenance-primary-button" onClick={onRetry}>Try again</button>}
    </section>
  );
}

export const formatMaintenanceDate = value => {
  if (!value) return 'Not recorded';
  const normalized = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(String(value)) ? `${String(value).replace(' ', 'T')}Z` : value;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat('en-MY', {
    day: '2-digit', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'Asia/Kuala_Lumpur'
  }).format(date);
};

export const maintenanceStatusLabel = value => String(value || 'open').replace(/\b\w/g, letter => letter.toUpperCase());
export const maintenancePriorityLabel = value => ({ 1: 'P1 Critical', 2: 'P2 High', 3: 'P3 Medium', 4: 'P4 Low' }[Number(value)] || 'Priority not set');
